import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class TermsAndConditionsEventBusService {
  public openTermsOfServiceModal$ = new EventEmitter();
  public openOpenSourceSoftwareModal$ = new EventEmitter();
  public openPrivacyPolicyModal$ = new EventEmitter();
  public openContactUsModal$ = new EventEmitter<void | string>();
}
